import script from "./message-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-details.vue?vue&type=script&lang=ts&setup=true"

import "./message-details.vue?vue&type=style&index=0&id=66092406&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66092406"]])

export default __exports__